export const checkError = (value: string | boolean, setErr: any, text: string): void => {
  if (!value) {
    setErr(text)
  }
}
